import {ApiEndpointBuilder} from 'services/api/types';
import {ResponseData} from 'types/response-data';
import {User} from 'types/user';

const updatePasswordEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation<ResponseData<User>, Request>({
    query: newPasswordInfo => ({
      url: 'me/account',
      method: 'PUT',
      body: newPasswordInfo,
    }),
  });
};

type Request = {};

export default updatePasswordEndpoint;
